import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ElementRef,
  HostBinding,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { WalkTroughPopoverService } from '../../services/walk-trough-popover.service';
import { AnalyticsService } from '@geneplanet/ngx-utils';
@Component({
  selector: 'app-walk-trough',
  templateUrl: './walk-trough-popover.component.html',
  styleUrls: ['./walk-trough-popover.component.scss'],
})
export class WalkTroughComponent implements OnInit, OnDestroy {
  @Input() walkTroughId: string;
  @Input() title: string = null;
  @Input() text: string = null;

  @HostBinding('class.d-flex') display = true;

  step: number;
  totalSteps: number;
  showPopover = false;

  private destroy$ = new Subject<void>();

  constructor(
    public elRef: ElementRef,
    private popoverService: WalkTroughPopoverService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.popoverService
      .listen()
      .pipe(
        filter(
          () => this.popoverService.getWalkTroughId() === this.walkTroughId
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.step = this.popoverService.getStep();
        this.totalSteps = this.popoverService.getTotalSteps();
        this.showPopover = true;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.showPopover = false;
  }

  skip() {
    this.popoverService.complete();
    this.showPopover = false;
    this.analyticsService.trackClicksManually('walkthrough-skip');
  }

  next() {
    this.popoverService.next();
    this.showPopover = false;
    this.analyticsService.trackClicksManually(
      this.step === this.totalSteps ? 'walkthrough-got-it' : 'walkthrough-next'
    );
  }
}
